import createStore from "./createStore";
// eslint-disable-next-line import/no-mutable-exports
export var pageHistoryStore;
export var getpageHistoryStoreValue = function() {
    if (!pageHistoryStore) {
        pageHistoryStore = createStore({
            pageStack: []
        });
    }
    return pageHistoryStore.value;
};

//# sourceMappingURL=pageHistoryStore.js.map